import { useState, useEffect } from 'react'
import { useAuth } from '../hooks/useAuth'
import { apiFetch } from '../lib/api'

export function Home() {
  const { user } = useAuth()
  const [code, setCode] = useState<string | null>(null)
  const [expiresAt, setExpiresAt] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchCurrentCode()
  }, [])

  async function fetchCurrentCode() {
    try {
      const data = await apiFetch('/api/code/current')
      if (data.code) {
        setCode(data.code)
        setExpiresAt(data.expires_at)
      }
    } catch {}
  }

  async function generateCode() {
    setLoading(true)
    try {
      const data = await apiFetch('/api/code/generate', { method: 'POST' })
      setCode(data.code)
      setExpiresAt(data.expires_at)
    } catch (err) {
      alert('Failed to generate code. Try again.')
    }
    setLoading(false)
  }

  function getTimeLeft() {
    if (!expiresAt) return null
    const diff = new Date(expiresAt).getTime() - Date.now()
    if (diff <= 0) return 'Expired'
    const hours = Math.floor(diff / (1000 * 60 * 60))
    const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    return `${hours}h ${mins}m left`
  }

  return (
    <div className="page home">
      <header className="header">
        <h1>DIGSAFE</h1>
        {user?.name && <p className="greeting">Hi, {user.name}</p>}
      </header>

      <section className="code-section">
        {code ? (
          <div className="code-card">
            <p className="code-label">Your code</p>
            <p className="code-value">{code}</p>
            <p className="code-expiry">{getTimeLeft()}</p>
            <p className="code-instruction">Show this at the hotel desk</p>
            <button className="btn-secondary" onClick={generateCode} disabled={loading}>
              Refresh code
            </button>
          </div>
        ) : (
          <div className="code-card empty">
            <p>No active code</p>
            <button className="btn-primary" onClick={generateCode} disabled={loading}>
              {loading ? 'Generating...' : 'Get code'}
            </button>
          </div>
        )}
      </section>

      <section className="info-section">
        <div className="info-card">
          <h3>🏨 How it works</h3>
          <ol>
            <li>Get a code above</li>
            <li>Call or visit a partner hotel</li>
            <li>Show your code at the desk</li>
            <li>Pay £44/night (inside your allowance)</li>
          </ol>
        </div>

        <div className="info-card">
          <h3>💰 Your savings</h3>
          <p>vs rack rate (~£80/night):</p>
          <p className="savings">Save £36/night</p>
          <p className="savings-sub">= £288/month at 8 nights</p>
        </div>
      </section>
    </div>
  )
}
